export enum StoryType {
    Bookmark = 'bookmark',
    Module = 'module'
}
